import type { ScopeOfWorkContent } from '@/blocks/domain/types/BlockContent/ProseContent';
import { fromProseContent, mapProseContent, type ProseContentDtoFor } from '@/blocks/application/mappers/blockProseMapper';

export function mapScopeOfWorkContent(dto: ProseContentDtoFor<'scope_of_work'>): ScopeOfWorkContent {
  return mapProseContent(dto) as ScopeOfWorkContent;
}

export function fromScopeOfWorkContent(content: ScopeOfWorkContent): ProseContentDtoFor<'scope_of_work'> {
  return fromProseContent(content) as ProseContentDtoFor<'scope_of_work'>;
}
